import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Interaccion',
  alias: ['/sistema/crm/Interaccion/Index'],
  documento: 'crm',
  filas: ['142'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/InteraccionController.cs',
} satisfies RutaProd;
